const d = document;

/**
 * IRニュースリスト生成クラス
 */
export default class IRNewsAPI {
  /** 設定 */
  config = null;

  /** コールバック関数名 */
  callbackId = '';

  /** @private イベントリスナー */
  #listeners = {};

  /**
   * コンストラクタ
   * @param {Object} config 設定
   */
  constructor(config) {
    this.config = config;
  }

  /**
   * @param {Object} data 送信データ
   * @return {URLSearchParams} リクエスト用パラメータ（callbackを除く）
   */
  getParams(data) {
    // 必須の種別パラメータが無かったらエラーにする
    if (!data || !data.doctype) {
      throw new Error('API param requires doctype.');
    }

    const params = new URLSearchParams();
    const config = this.config;

    // API必須パラメータ
    const apiParams = config.getApiParams();
    params.set('company', apiParams.company);
    params.set('output', apiParams.output);

    // 絞り込み種別
    params.set('doctype', config.getDoctypeIds(data.doctype).join(','));

    // 絞り込み開始日
    if (data.pdate && data.pdate !== '') {
      params.set('pdate', data.pdate);
    }

    // 絞り込み終了日
    if (data.fdate && data.fdate !== '') {
      params.set('fdate', data.fdate);
    }

    // 取得件数
    if (data.len && data.len > 0) {
      params.set('len', data.len);
    }

    // キャッシュ回避用のタイムスタンプ
    params.set('_', Date.now());

    return params;
  }

  /**
   * コールバック関数名を生成
   * @return {String} コールバック関数名
   */
  createCallbackId() {
    let callbackId = (this.constructor.name + Math.random()).replace(/\./g, '_');

    if (!!window[callbackId]) {
      callbackId = this.getCallbackId();
    }

    return callbackId;
  }

  /**
   * 連続呼び出しで前のコールバック関数があったら削除
   * @param {Boolean} isImmediate 即時削除フラグ
   */
  clearCallback(isImmediate) {
    if (this.callbackId && window[this.callbackId]) {
      if (isImmediate) {
        delete window[this.callbackId];
      } else {
        const _callbackId = this.callbackId;
        window[_callbackId] = () => {
          if (window[_callbackId]) {
            delete window[_callbackId];
          }
        };
      }
    }
  }

  /**
   * データ取得
   * @param {Object} data 送信データ
   */
  load(data) {
    // 連続呼び出しで前のコールバック関数があったら削除
    this.clearCallback();

    // JSONPのコールバックを登録
    const callbackId = this.callbackId = this.createCallbackId();
    window[callbackId] = this.onReceive.bind(this);

    // パラメータを取得してコールバックを設定
    const params = this.getParams(data);
    params.append('callback', callbackId);

    // データをJSONPで読み込む
    // URLSearchParamsとAPIの都合上、%2Cをカンマに戻す
    const url = new URL(location.protocol + this.config.getApiRoot() + '?' + params.toString().replace(/%2C/g, ','));
    const $script = d.createElement('script');
    $script.async = true;
    $script.setAttribute('src', url);
    d.querySelector('head').appendChild($script);
  }

  /**
   * イベントリスナー登録
   * @param {String} eventType イベント名
   * @param {Function} listener イベントリスナー
   */
  on(eventType, listener) {
    if (!this.#listeners[eventType]) {
      this.#listeners[eventType] = [];
    }
    this.#listeners[eventType].push(listener);
  }

  /**
   * イベントリスナー削除
   * @param {String} eventType イベント名
   * @param {Function} listener イベントリスナー
   */
  off(eventType, listener) {
    if (!this.#listeners[eventType]) {
      return;
    }

    const listeners = this.#listeners[eventType];
    for (let i = 0, n = listeners.length; i < n; i++) {
      if (listeners[i] === listener) {
        listeners.splice(i, 1);
        break;
      }
    }
  }

  /**
   * イベント発火
   * @param {String} eventType イベント名
   * @param {Any} data データ
   */
  trigger(eventType, data) {
    if (!this.#listeners[eventType]) {
      return;
    }

    this.#listeners[eventType].forEach((listener) => {
      listener(data);
    });
  }

  /**
   * JSONPのコールバック
   * @param {Object} datas データ
   */
  onReceive(datas) {
    this.clearCallback(true);
    this.trigger('load', datas);
  }
}
